import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/userRequests/UserRequestsPage.vue"),
    meta: {
      accessLevel: "organisation_read",
      title: "User Requests",
    },
    name: "user-requests",
    path: "/user_requests",
    props: (route) => typecastRouteProps(route),
  },
];
